import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDiseaseList, getDiseaseInfo } from '@store/actions/commonAction';
import Layout from '@components/common/Layout';

const DissTerms = () => {
  const dispatch = useDispatch();
  const [groupInfo, setGroupInfo] = useState([]); // 카테고리 목록
  const [groupingResult, setGroupingResult] = useState({}); // 질병 목록

  const [selectedGroup, setSelectedGroup] = useState(''); // 선택 카테고리
  const [selectedDis, setSelectedDis] = useState({}); // 선택 질병
  const [selectedGroupResult, setSelectedGroupResult] = useState([]); // 선택 질병 목록
  const [selectedDisContent, setSelectedDisContent] = useState([]); // 질병 내용
  const [filterText, setFilterText] = useState(''); // 필터 텍스트

  useEffect(() => {
    // 초기화
    const callback = ({ groupInfo, groupingResult }) => {
      // select option 셋팅
      setGroupInfo(groupInfo);
      setGroupingResult(groupingResult);

      // 기본값 셋팅
      const disGrpCd = groupInfo[0].disGrpCd;
      setSelectedGroup(disGrpCd);
      setSelectedGroupResult(groupingResult[disGrpCd]);
      setSelectedDis(groupingResult[disGrpCd][0]);
    };
    // 질병 카테고리 조회
    dispatch(
      getDiseaseList({
        callback,
      }),
    );
  }, []);

  // 질병 카테고리 변경
  const handleChangeGroup = e => {
    const disGrpCd = e.target.value;
    setSelectedGroup(disGrpCd);
    setSelectedGroupResult(groupingResult[disGrpCd]);
    setSelectedDis(groupingResult[disGrpCd][0]);
  };

  // 질병명 선택
  const handleChangeGroupResult = e => {
    const disNo = e.target.value;
    const callback = data => {
      setSelectedDis(selectedGroupResult.find(data => data.disNo === disNo));
      setSelectedDisContent(data);
    };
    // 질병 내용 검색
    dispatch(
      getDiseaseInfo({
        params: {
          disNo,
        },
        callback,
      }),
    );
  };

  const handleFilterGroupResult = e => {
    setFilterText(e.target.value);
  };

  useEffect(() => {
    if (
      !$utils.isEmptyObject(groupingResult) &&
      !$utils.isEmptyString(selectedGroup)
    ) {
      const filteredList = groupingResult[selectedGroup].filter(
        data => data.korNm.trim().indexOf(filterText) > -1,
      );
      const selectedGroupResult =
        $utils.isEmptyString(filterText) || filteredList.length === 0
          ? groupingResult[selectedGroup]
          : filteredList;

      setSelectedGroupResult(selectedGroupResult);
    }
  }, [groupingResult, selectedGroup, filterText]);

  $hooks.useDebounce({
    value: selectedGroupResult,
    callback: () => {
      handleChangeGroupResult({
        target: { value: selectedGroupResult[0]?.disNo },
      });
    },
  });

  return (
    <Layout>
      <div className="con-wrap tablet disease_terms_wrap">
        <div className="app-box">
          <div className="tit-area">
            <h2 className="tit-con">질병용어사전</h2>
          </div>
          <div className="search-box">
            <div className="data-group-left">
              <div className="sel-group sel-wide3">
                <select value={selectedGroup} onChange={handleChangeGroup}>
                  {!$utils.isEmptyArray(groupInfo) &&
                    groupInfo.map(({ disGrpCd, disGrpNm }) => (
                      <option key={disGrpCd} value={disGrpCd}>
                        {disGrpNm}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <div className="data-group-left">
              <div className="sel-group sel-wide2">
                <select
                  value={selectedDis?.disNo}
                  onChange={handleChangeGroupResult}
                >
                  {!$utils.isEmptyArray(selectedGroupResult) &&
                    selectedGroupResult.map(result => (
                      <option key={result.disNo} value={result.disNo}>
                        {result.korNm}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <div className="data-group-left">
              <div className="input-wrap input-search">
                <input
                  type="text"
                  id="text1"
                  className="input"
                  placeholder="검색어를 입력하세요."
                  onKeyUp={handleFilterGroupResult}
                />
              </div>
            </div>
          </div>
          <div className="resultContBox">
            <div className="resultContItem">
              <h3 className="txtC2">{selectedDis?.korNm}</h3>
              <div className="result_wrap">
                {!$utils.isEmptyArray(selectedDisContent) &&
                  selectedDisContent.map(content => {
                    const parser = new DOMParser();
                    const htmlString = parser.parseFromString(
                      content.dscCnts,
                      'text/html',
                    );
                    const _html = htmlString.documentElement.textContent;
                    return (
                      <div className="result_group" key={content.ttlNo}>
                        <h4 className="txtC2">{`■ ${content.ttlNm}`}</h4>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: _html,
                          }}
                        />
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default DissTerms;
